import React from 'react';
import classNames from 'classnames';
import './FooterDelete.css';

type Props = {
  onClick?: (ev: React.MouseEvent) => void;
  onKeyPress?: (ev: React.KeyboardEvent) => void;
  className?: string;
  role?: string;
  tabIndex?: number;
};

const FooterDelete = ({ onClick, className, onKeyPress, role, tabIndex }: Props) => (
  <svg
    className={classNames('footer-delete', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 24 24"
    onClick={onClick}
    onKeyPress={onKeyPress}
    role={role}
    tabIndex={tabIndex}
  >
    <path d="M24 20.188l-8.315-8.209 8.2-8.282-3.697-3.697-8.212 8.318-8.31-8.203-3.666 3.666 8.321 8.24-8.206 8.313 3.666 3.666 8.237-8.318 8.285 8.203z" />
  </svg>
);

export default FooterDelete;
